import { Star } from '@mui/icons-material';
import { Box, Chip, Stack, Typography, useTheme } from '@mui/material';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type BenefitCheckListProps = Readonly<{
	value: readonly string[];
	onChange(newBenefits: readonly string[]): void;
	loading?: boolean;
}>;

const ICON_SIZE = {
	width: '16px',
	height: '16px',
};

export const BenefitCheckList: FC<BenefitCheckListProps> = ({ value, onChange, loading }) => {
	const theme = useTheme();

	const stars = [
		{ id: '1', icon: <Star /> },
		{ id: '2', icon: <Star /> },
		{ id: '3', icon: <Star /> },
		{ id: '4', icon: <Star /> },
		{ id: '5', icon: <Star /> },
	];

	const selectedStars = value.filter((value) => stars.some((o) => o.id === value));

	if (loading) {
		return (
			<Typography sx={{ color: theme.palette.secondary.main }}>
				<FormattedMessage id={'common.loading'} />
			</Typography>
		);
	}

	return (
		<Stack direction={'column'} gap={2}>
			{stars.length > 0 && (
				<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
					{stars.map((star) => (
						<Chip
							key={star.id}
							label={
								<Box display={'flex'} sx={{ alignItems: 'center', justifyContent: 'center' }}>
									{[...Array(Number(star.id))].map((_, index) => React.cloneElement(star.icon, { sx: { color: 'inherit', ...ICON_SIZE } }))}
								</Box>
							}
							variant={'outlined'}
							sx={{
								backgroundColor: theme.palette.secondary.lighter,
								cursor: 'pointer',
								opacity: selectedStars.includes(star.id) ? 1 : 0.5,
								color: selectedStars.includes(star.id) ? theme.palette.primary.main : theme.palette.secondary.light,
							}}
							onClick={() =>
								selectedStars.includes(star.id)
									? onChange(selectedStars.filter((pId) => pId !== star.id))
									: onChange(selectedStars.concat(star.id))
							}
						/>
					))}
				</Box>
			)}
		</Stack>
	);
};
